import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 환경변수 기반
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  },
});

export default api
